import React, { PropTypes } from 'react';
import moment from 'moment';
// import { isDate } from "lodash";
import Filter from '../Filter';

import { NitroPlaceholder, NitroDatePicker } from 'nitro-components';
import SingleSelect from '../single-select/SingleSelect';

import styled from 'styled-components';

const DatePickerContainer = styled.div`
  margin-bottom: 16px;
`;

class DateRange extends Filter {
  static getLabel = filter => {
    const label = Filter.getLabel(filter);

    if (filter.type === 'custom') {
      const { start, end } = filter.value;

      const startString = moment(start).format('D MMM YYYY');
      const endString = moment(end).format('D MMM YYYY');
      return `${startString} - ${endString}`;
    }

    return label;
  };

  handleOptionSelect = option => {
    const { value, label } = option;

    this.props.action({
      type: value === 'custom' ? 'custom' : 'DATE',
      value: value,
      label: label,
      isRollingDate: value === 'custom' ? false : true
    });
  };

  setStartDate = date => {
    const { filter } = this.props;
    const { value } = filter;

    // const start = moment(date).format('YYYY-MM-DD');
    const start = date;
    const end = value.end;
    const label = DateRange.getLabel({ type: 'custom', value: { start, end } });

    this.props.action({ type: 'custom', label, value: { start, end } });
  };

  setEndDate = date => {
    const { filter } = this.props;
    const { value } = filter;

    // const end = moment(date).format('YYYY-MM-DD');
    const end = date;
    const start = value.start;
    const label = DateRange.getLabel({ type: 'custom', value: { start, end } });

    this.props.action({ type: 'custom', label, value: { start, end } });
  };

  getDateObject = dateString => {
    return dateString;
  };

  getDateCustomizer() {
    const { start, end } = this.props.filter.value;
    // const startDate = this.getDateObject(start);
    // const endDate = this.getDateObject(end);

    let startDatePicker = null;

    startDatePicker = (
      <NitroDatePicker
        placeholder="Start Date"
        value={start}
        onChange={this.setStartDate}
      />
    );

    let endDatePicker = null;
    endDatePicker = (
      <NitroDatePicker
        placeholder="End Date"
        value={end}
        onChange={this.setEndDate}
      />
    );

    return (
      <section>
        <NitroPlaceholder size={10} />
        <DatePickerContainer>{startDatePicker}</DatePickerContainer>
        <DatePickerContainer>{endDatePicker}</DatePickerContainer>
      </section>
    );
  }

  render() {
    const { filter } = this.props;
    const { value, type, options } = filter;

    const customOption = {
      label: 'Custom range ...',
      value: 'custom'
    };

    let option;

    if (options) {
      option = [...options, customOption];
    } else {
      option = [customOption];
    }

    const selectFilter = {
      value: type === 'custom' ? 'custom' : value,
      options: option
    };

    return (
      <section>
        <SingleSelect filter={selectFilter} action={this.handleOptionSelect} />
        {type === 'custom' ? this.getDateCustomizer() : null}
      </section>
    );
  }
}

DateRange.propTypes = {
  action: PropTypes.func,
  filter: PropTypes.object.isRequired
};

export default DateRange;



// WEBPACK FOOTER //
// ./src/components/filter/filters/date-range/DateRangeReport.js